import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import ApiLogs from '../entities/api-logs'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';

interface ApiLogsState extends ListState<ApiLogs> {

    permissions: Array<string>
}

class ApiLogsModule extends ListModule<ApiLogsState, any, ApiLogs> {
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<ApiLogs>(),
        loading: false,
        permissions: new Array<string>()
    }
    actions = {
        async getAll(context: ActionContext<ApiLogsState, any>, payload: any) {
            context.state.loading = true;
            let response = await Ajax.get('/api/services/app/ApiLogs/GetAll', { params: payload.data });
            context.state.loading = false;
            let page = response.data.result as PageResult<ApiLogs>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },


        async get(context: ActionContext<ApiLogsState, any>, payload: any) {
            let response = await Ajax.get('/api/services/app/ApiLogs/Get?Id=' + payload.id);
            return response.data.result as ApiLogs;
        },

    };
    mutations = {
        setCurrentPage(state: ApiLogsState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: ApiLogsState, pagesize: number) {
            state.pageSize = pagesize;
        },

    }
}

const apiLogsModule = new ApiLogsModule();
export default apiLogsModule;